import { Component, OnInit, Input, Optional, Self, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FieldConventionService } from 'src/app/stp/stp-app/forms';
import { NgControl, ControlValueAccessor } from '@angular/forms';
import { MatCheckbox } from '@angular/material';

@Component({
  selector: 'stp-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {

  @Input() label: string;

  @ViewChild(MatCheckbox) private matCheckbox: MatCheckbox;

  constructor(
    @Optional() @Self() private ngControl: NgControl,
    private fieldConventionService: FieldConventionService) {
      this.ngControl.valueAccessor = this;
  }

  ngOnInit() {
    if (!this.label) {
      this.label = this.fieldConventionService.getDefaultLabel(this.ngControl.name);
    }
  }

  writeValue(obj: any): void {
    this.matCheckbox.writeValue(obj);
  }

  registerOnChange(fn: any): void {
    this.matCheckbox.registerOnChange(fn);
  }

  registerOnTouched(fn: any): void {
    this.matCheckbox.registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.matCheckbox.setDisabledState(isDisabled);
  }
}
